import type { ReactElement } from 'react'
import type { TFunction } from 'i18next'
import { Column } from 'primereact/column'
import Button from '../../../components/ui/Button'
import { sortLocalized, type LocalizedText } from '../../../lib/localizedText'
import type { ReferansItem } from '../types'

interface ColumnOpts {
  t: TFunction
  /** Ad kolonu tek kolondur ve değeri seçili dilden gelir (bkz. `lib/localizedText`). */
  localized: LocalizedText
  onEdit: (row: ReferansItem) => void
  /**
   * Salt okunur kip (126 — Kısıtlı Yetkili asistan): işlemler kolonu hiç çizilmez. Tip ve ad tabloda
   * zaten göründüğü için ayrı bir görüntüleme eylemine gerek yoktur.
   */
  readOnly?: boolean
}

/** Referans tablosu sütunları (tip/ad/sıra + Ad düzenleme aksiyonu — 018). */
export function referansColumns({ t, localized, onEdit, readOnly = false }: ColumnOpts): ReactElement[] {
  const columns = [
    <Column key="type" field="type" header={t('admin.referans.columns.type')} sortable />,
    <Column
      key="name"
      header={t('admin.referans.columns.name')}
      // Sıralama GÖRÜNEN değere göre: `field` verilseydi İngilizce arayüzde TR adına göre sıralanır,
      // yani başlık kullanıcıya yanlış söylerdi.
      sortable
      sortFunction={(e) =>
        sortLocalized(e.data as ReferansItem[], localized, (r) => [r.nameTr, r.nameEn], e.order)
      }
      body={(row: ReferansItem) => localized(row.nameTr, row.nameEn)}
    />,
    <Column
      key="actions"
      header={t('admin.referans.columns.actions')}
      style={{ width: '6rem' }}
      body={(row: ReferansItem) => (
        <div className="admin-row-actions">
          <Button
            icon="pi pi-pencil"
            rounded
            text
            label={t('admin.referans.actions.edit')}
            aria-label={t('admin.referans.actions.edit')}
            onClick={() => onEdit(row)}
          />
        </div>
      )}
    />,
  ]
  // Salt okunurda tek eylem (Düzenle) düşer → kolon boş kalacağı için tümüyle çıkarılır.
  return readOnly ? columns.filter((c) => c.key !== 'actions') : columns
}
